import { z } from 'zod';
// Zod schemas for validation
/**
 * Schema for validating cycle status
 */
export const CycleStatusSchema = z.enum(['setup', 'active', 'review', 'completed', 'locked']);
/**
 * Custom Zod schema for Timestamp validation
 */
const TimestampSchema = z.object({
    seconds: z.number(),
    nanoseconds: z.number(),
    toDate: z.function(),
    toMillis: z.function(),
});
/**
 * Schema for validating cycle dates
 */
export const CycleDatesSchema = z.object({
    setupStart: TimestampSchema,
    collectionStart: TimestampSchema,
    collectionEnd: TimestampSchema,
    reviewEnd: TimestampSchema,
    locked: TimestampSchema.optional(),
});
/**
 * Schema for validating complete collection cycle data
 */
export const CollectionCycleSchema = z.object({
    id: z.string().min(1),
    name: z.string().min(1),
    status: CycleStatusSchema,
    dates: CycleDatesSchema,
    totalClients: z.number().min(0),
    totalAssignments: z.number().min(0),
    completedAssignments: z.number().min(0),
    createdBy: z.string().min(1),
    createdAt: TimestampSchema,
    updatedAt: TimestampSchema,
});
/**
 * Schema for validating cycle creation data
 */
export const CreateCycleDataSchema = z.object({
    id: z.string().min(1),
    name: z.string().min(1),
    dates: CycleDatesSchema,
    totalClients: z.number().min(0),
    createdBy: z.string().min(1),
});
/**
 * Schema for validating cycle update data
 */
export const UpdateCycleDataSchema = z.object({
    name: z.string().min(1).optional(),
    status: CycleStatusSchema.optional(),
    dates: CycleDatesSchema.partial().optional(),
    totalClients: z.number().min(0).optional(),
    totalAssignments: z.number().min(0).optional(),
    completedAssignments: z.number().min(0).optional(),
});
/**
 * Type guards for cycle data
 */
export const isValidCollectionCycle = (data) => {
    return CollectionCycleSchema.safeParse(data).success;
};
export const isValidCycleStatus = (status) => {
    return CycleStatusSchema.safeParse(status).success;
};
export const isValidCycleDates = (dates) => {
    return CycleDatesSchema.safeParse(dates).success;
};
export const isValidCreateCycleData = (data) => {
    return CreateCycleDataSchema.safeParse(data).success;
};
export const isValidUpdateCycleData = (data) => {
    return UpdateCycleDataSchema.safeParse(data).success;
};
